var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHiking = function SvgHiking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#061F15",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m13.02 16.039-4.808 1.923-1.923-4.808v-1.923l-2.885-.962-1.923 8.654c-.279 1.395 0 2.885 1.923 3.847l4.808 2.884v7.693M4.365 23.73v2.884l-3.404 5.77M8.604 4.5a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0Z"
  })));
};
export default SvgHiking;